import { useEffect, useRef } from 'react';
import { useToast } from '../components/ToastNotification';

/**
 * Listens for global 401/403 auth error events dispatched by the Supabase fetch
 * interceptor and shows appropriate toast notifications.
 */
const useApiErrorHandler = () => {
  const { showAuthError } = useToast();
  // Debounce repeated events (e.g. multiple parallel requests failing at once)
  const lastShownRef = useRef({});

  useEffect(() => {
    const handleAuthError = (event) => {
      const status = event?.detail?.status;
      if (!status) return;

      const now = Date.now();
      const last = lastShownRef?.current?.[status] || 0;
      // Only show once per 10 seconds per status code
      if (now - last < 10000) return;
      lastShownRef.current[status] = now;

      showAuthError(status);
    };

    window.addEventListener('app:auth-error', handleAuthError);
    return () => window.removeEventListener('app:auth-error', handleAuthError);
  }, [showAuthError]);
};

export default useApiErrorHandler;
